import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("dgnbp"), parcelRequire.load("jgwQt"), parcelRequire.load("6qO4J"), parcelRequire.load("hkpo7"), parcelRequire.load("aKBno"), parcelRequire.load("dwEcD"), parcelRequire.load("gTWSG"), parcelRequire.load("gzLGy"), parcelRequire.load("95APl"), parcelRequire.load("lH05e"), parcelRequire.load("45RYB"), parcelRequire.load("kIvY2"), parcelRequire.load("gq8cw")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("dgnbp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("jgwQt")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6qO4J")} />
  <link rel="modulepreload" href={parcelRequire.resolve("hkpo7")} />
  <link rel="modulepreload" href={parcelRequire.resolve("aKBno")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dwEcD")} />
  <link rel="modulepreload" href={parcelRequire.resolve("gTWSG")} />
  <link rel="modulepreload" href={parcelRequire.resolve("gzLGy")} />
  <link rel="modulepreload" href={parcelRequire.resolve("95APl")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lH05e")} />
  <link rel="modulepreload" href={parcelRequire.resolve("45RYB")} />
  <link rel="modulepreload" href={parcelRequire.resolve("kIvY2")} />
  <link rel="modulepreload" href={parcelRequire.resolve("gq8cw")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
